export const SliderData = [
  {
    image: "https://res.cloudinary.com/doas1ztbf/image/upload/v1613488021/image_dwqmcj.png"
  },
  {
    image: "https://images.unsplash.com/photo-1582492065409-9315e8075a2c?ixid=MXwxMjA3fDB8MHxzZWFy[…]58MHx8MHw%3D&ixlib=rb-1.2.1&auto=format&fit=crop&w=500&q=60"
  },
  {
    image: "https://images.unsplash.com/photo-1604610728890-6f4b631ed081?ixid=MXwxMjA3fDB8MHxzZWFy[…]58MHx8MHw%3D&ixlib=rb-1.2.1&auto=format&fit=crop&w=500&q=60"
  },
  {
    image: "https://images.unsplash.com/photo-1572037942224-2217d39e2b48?ixid=MXwxMjA3fDB8MHxzZWFy[…]fGVufDB8fDB8&ixlib=rb-1.2.1&auto=format&fit=crop&w=500&q=60"
  },
  {
    image: "https://images.unsplash.com/photo-1580647125449-980da4c24459?ixid=MXwxMjA3fDB8MHxzZWFy[…]58MHx8MHw%3D&ixlib=rb-1.2.1&auto=format&fit=crop&w=500&q=60"
  },
  {
    image: "https://images.unsplash.com/photo-1534659477036-c05235c62402?ixid=MXwxMjA3fDB8MHxzZWFy[…]58MHx8MHw%3D&ixlib=rb-1.2.1&auto=format&fit=crop&w=500&q=60"
  },
  {
    image: "https://images.unsplash.com/photo-1513506003901-1e6a229e2d15?ixid=MXwxMjA3fDB8MHxzZWFy[…]fHwwfA%3D%3D&ixlib=rb-1.2.1&auto=format&fit=crop&w=500&q=60"
  },
  {
    image: "https://images.unsplash.com/photo-1475783006851-1d68dd683eff?ixid=MXwxMjA3fDB8MHxzZWFy[…]fHwwfA%3D%3D&ixlib=rb-1.2.1&auto=format&fit=crop&w=500&q=60"
  },
];